import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-exam-grievance-redressal-committee',
  templateUrl: './exam-grievance-redressal-committee.component.html',
  styleUrls: ['./exam-grievance-redressal-committee.component.scss']
})
export class ExamGrievanceRedressalCommitteeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
